import * as React from 'react';
import { Config } from '../../helper';
import CardSearchResult from './CardSearchResult';
import AccordionSearchResult from './AccordionSearchResult';

export default function SearchResult({viewMode}) {
  if (!viewMode) return null;

  if (viewMode.viewMode === Config.ViewModes.Accordion) {
    return <AccordionSearchResult displayOptions={viewMode}/>;
  }

  return <CardSearchResult displayOptions={viewMode}/>;
}
